import { render, staticRenderFns } from "./DialogHeaderWithButtons.vue?vue&type=template&id=513a2885"
import script from "./DialogHeaderWithButtons.vue?vue&type=script&lang=js"
export * from "./DialogHeaderWithButtons.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../photo-retention-20261014/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports